import React from 'react'
export const StarImg = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="300" height="290" viewBox="0 0 215 290" fill="none">
  <path d="M-40 2.10809L246.44 288.548M246.44 2.10809L-40 288.548M-40 145.328H246.44M103.22 2.10809V288.548" stroke="black" strokeWidth="3.51523" strokeLinejoin="round"/>
</svg>
  )
}
